import { createColumnHelper } from '@tanstack/react-table';
import { Tag, TagTypes } from '@monorepo/base/src/components/tag/tag';
import { IMergedHeadersReturn } from './index.headers';
import { IAdminxStore } from '../../stores';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { useEffect } from 'react';
import { ApiChangeLogModel, IApiChangeLogItem } from '../../models/bidder-logs.model';

const columnHelper = createColumnHelper<ApiChangeLogModel & IApiChangeLogItem>();

export const useBidderChangesLogsHeaders = (): IMergedHeadersReturn<ApiChangeLogModel> => {
	const { settingsStore } = useStores<IAdminxStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();
	const tableStore = settingsStore.pages.get(currentRouteWithoutSpecialChars)?.tableStore;

	useEffect(() => {
		if (tableStore && Object.keys(tableStore.getColumnVisibility()).length === 0) {
			tableStore.setDefaultColumnVisibility({
				campaign_id: true,
				type: true,
				field: true,
				old_value: true,
				new_value: true,
				user_email: true,
				session_id: false,
				request_id: false,
				ts: true,
			});
			tableStore?.setColumnVisibility(tableStore.getDefaultColumnVisibility());
		}
	}, [tableStore]);

	return {
		columns: [
			columnHelper.accessor('ts', {
				header: 'Timestamp',
			}),
			columnHelper.accessor('campaign_id', {
				header: 'Campaign ID',
			}),
			columnHelper.accessor('type', {
				header: 'Type',
				cell: info => {
					const type = info.getValue();
					return <Tag type={TagTypes.Info}>{type.replace(/_/g, ' ')}</Tag>;
				},
			}),
			columnHelper.accessor('field', {
				header: 'Field',
			}),
			columnHelper.accessor('old_value', {
				header: 'Old Value',
			}),
			columnHelper.accessor('new_value', {
				header: 'New Value',
				size: 60,
			}),
			columnHelper.accessor('user_email', {
				header: 'User Email',
			}),
			columnHelper.accessor('session_id', {
				header: 'Session ID',
			}),
			columnHelper.accessor('request_id', {
				header: 'Request ID',
			}),
		],
	};
};
